import { EarthBoxOffIcon } from './EarthBoxOffIcon';

/**
 * author: GreenTurtwig
 * id CAE8B8BC-E89F-49C3-8178-6F09ACED1FC3
 * name earth-box-off
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-box-off.svg
 * tags
 * - Navigation 
 */
export const PlanetBoxOffIcon = EarthBoxOffIcon;
export default PlanetBoxOffIcon